import styles from './Hint.module.scss'
import { ReactComponent as HintLeft } from './hintLeft.svg'
import { ReactComponent as HintTop } from './hintTop.svg'

const Hint = ({
  title,
  description,
  isActive,
  width,
  left,
  top,
  right,
  hintPosition = 'bottom'
}) => (
  <div
    className={isActive ? styles.activeHint : styles.hint}
    style={{
      width,
      left: hintPosition === 'right' ? right + 20 : left,
      top: hintPosition === 'bottom' ? top + 50 : top - 26
    }}
  >
    {hintPosition === 'bottom' && <HintTop className={styles.hintTop} />}
    {hintPosition === 'right' && <HintLeft className={styles.hintLeft} />}
    <div className={styles.hintTitle}>{title}</div>
    <div className={styles.hintDesc}>{description}</div>
  </div>
)

export default Hint
